



// $(document).ready(function(){
//   $.fn.isInViewport = function() {
//       var elementTop = $(this).offset().top;
//       var elementBottom = elementTop + $(this).outerHeight();
//       var viewportTop = $(window).scrollTop();
//       var viewportBottom = viewportTop + $(window).height();
//       return elementBottom > viewportTop && elementTop < viewportBottom;
//   };
  
  
  
  
//    function ScrollExecute() {
// //            if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
//                scrollNode = $('.snize-pagination-next').last();    
//                scrollURL = $('.snize-pagination-next').last().attr("href");
//                if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
//                    $.ajax({
//                        type: 'GET',
//                        url: 'https://lighting-shop-nz.myshopify.com/pages/search-results-page?q=product&page=4',
//                        beforeSend: function() {
//                            scrollNode.clone().empty().insertAfter(scrollNode).append('<img src=\"{{ "loading.gif" | asset_url }}\" />');
//                            scrollNode.hide();
//                        },
//                        success: function(data) {
//                            // remove loading feedback
                         
                        
//                            scrollNode.next().remove();
//                            var filteredData = $(data).find("a.snize-view-link");
                         
//                          $(".snize-search-results-content").append(filteredData)
// //                            filteredData.( $(".snize-search-results-content") );                   
//                        },
//                        dataType: "html"
//                    });
//                }
// //            }
//          }
  
  
  

//   $( window ).scroll(function() {
  
//     if($('.snize-pagination-next') && $('.snize-pagination-next').isInViewport($('.snize-pagination-next'))){
//       console.log('true');
      
// //        $.doTimeout( 'scroll', 200, ScrollExecute);
      
//       ScrollExecute();
      
      

//     }else{
//       console.log('false');
//     }

//   });
  	
	

  
 
  

 
       
  
  
// });
$(document).ready(function(){
    var scrolling = false;
  	 $(window).scroll(function(){
//       $('.snize-pagination-load-more')[0].click();
       
        if($('.snize-pagination-load-more') && $('.snize-pagination-load-more').length > 0  && !scrolling){
  		  scrolling = true;
          var windowScrollTop = $(window).scrollTop();
          var loadMoreTop = $('.snize-pagination-load-more').offset().top;
          var windowHeight = $(window).innerHeight();
          
          
          if(windowHeight + windowScrollTop >= (loadMoreTop + 50)){
             $('.snize-pagination-load-more')[0].click();
          }
          
          setTimeout(function(){scrolling = false}, 1000);
        }
    });

  
})
document.addEventListener('DOMContentLoaded', () => {
  const productJson = [...document.querySelectorAll('[data-product-json]')];
  if (productJson.length > 0) {
    productJson.forEach((product) => {
      const sectionId = "shopify-section-" + product.closest('[data-section-id]').dataset.sectionId;
      const variantSKU = document.querySelector('#' + sectionId + ' .variant-sku');
      const inputSelects = [...document.querySelectorAll('#' + sectionId + ' .single-option-selector')];
      const productInfo = JSON.parse(product.innerHTML);
      const inputValues = [];
      const optionValues = [];
      let count = 0;
      inputSelects.forEach((input) => {
        inputValues.push(input.value);
        optionValues.push(count);
        input.addEventListener('change', (evt) => {
          const currentValue = evt.currentTarget.value.toString();
          const changedIndex = inputSelects.indexOf(evt.target);
          inputValues[changedIndex] = currentValue;
          variantSKU.innerText = ' ';
          productInfo.variants.forEach((variant) => {
            if (JSON.stringify(variant.options) == JSON.stringify(inputValues)) {
              variantSKU.innerText = variant.sku;
            }
          });
        });
        count += 1;
      });
    });
  }
});
